module.exports = __webpack_public_path__ + "img/generate.df522c0.svg";